// ============================================================
// SessionKeyStore — abgeleiteter AES-Schlüssel lebt NUR im RAM.
// Niemals in localStorage / sessionStorage / IndexedDB schreiben!
// ============================================================

const CONFIG_KEY = 'amed_session_timeout_ms';
const DEFAULT_TIMEOUT_MS = 10 * 60 * 1000; // 10 Minuten

export function getConfiguredTimeoutMs(): number {
  const raw = localStorage.getItem(CONFIG_KEY);
  if (raw === null) return DEFAULT_TIMEOUT_MS;
  const parsed = parseInt(raw, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : DEFAULT_TIMEOUT_MS;
}

export class SessionKeyStore {
  private static derivedKey: CryptoKey | null = null;
  private static timeoutId: number | null = null;

  static set(key: CryptoKey): void {
    this.wipe(); // Vorherigen Key + Timer bereinigen
    this.derivedKey = key;
    this.resetTimeout();
    this.registerBeforeUnload();
  }

  static get(): CryptoKey | null {
    return this.derivedKey;
  }

  static isActive(): boolean {
    return this.derivedKey !== null;
  }

  /** Explizites Wipe — z.B. bei Logout oder Inaktivitäts-Timeout */
  static wipe(): void {
    this.derivedKey = null;
    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  /** Timer bei Aktivität zurücksetzen (z.B. bei Nutzereingabe aufrufen) */
  static resetTimeout(): void {
    if (this.timeoutId !== null) clearTimeout(this.timeoutId);
    this.timeoutId = window.setTimeout(() => {
      this.wipe();
      window.dispatchEvent(new CustomEvent('amed:session-expired'));
    }, getConfiguredTimeoutMs());
  }

  private static beforeUnloadRegistered = false;

  private static registerBeforeUnload(): void {
    if (this.beforeUnloadRegistered) return;
    this.beforeUnloadRegistered = true;
    window.addEventListener('beforeunload', () => {
      this.wipe();
    });
  }
}
